export default {"src":"/hub/_next/static/media/border_diagonal.eaeba8c9.svg","height":10,"width":5,"blurWidth":0,"blurHeight":0};